import styled from 'styled-components';
import { Panel, Row, Col } from 'rsuite';

export const StyledPanel = styled(Panel)`
  font-size: 15px;
  margin-right: 15px;
  .rs-panel-body {
    padding: 0;
  }
`;

export const StyledPickListNameRow = styled(Row)`
  padding: 2px;
  border: 1px solid #ddd;
  color: #000;
  background-color: #86cce7;
  border-top-left-raduis: 4px;
  border-top-right-raduis: 4px;
  text-transform: uppercase;
  fort-style: bold;
`;

export const StyledCategoryNameRow = styled(Row)`
  padding: 2px;
  color: #000;
  background-color: #efefef;
  text-align: center;
`;

export const StyledCategoryItemsRow = styled(Row)`
  text-transform: uppercase;
  font-size: 14px;
  margin-top: 1px;
  margin-bottom: 1px;
`;

export const StyledItemName = styled(Col)`
  text-align: left;
`;

export const StyledItemQuantity = styled(Col)`
  text-align: right;
  font-weight: bold;
`;

export const Notes = styled.div`
  padding: 10px;
  font-style: italic;
  border-top: 1px solid #ddd;
`;
